import { Component, OnInit, signal } from '@angular/core';
import { environment } from '../environments/environment.development';
import { PostResponse } from './interfaces/common.interface';
import { AuthService } from './services/auth.service';
import { StorageService } from './services/storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.scss',
})
export class App implements OnInit {
  constructor(
    private _authServ: AuthService,
    private _storageServ: StorageService
  ) {
    const vr = environment.version;
    const lvr = localStorage.getItem('version');
    if (lvr && lvr != vr) {
      localStorage.setItem('version', vr);
      window.location.reload();
    } else {
      localStorage.setItem('version', vr);
    }
  }
  ngOnInit(): void {
    window.addEventListener('message', (event: MessageEvent<PostResponse>) => {
      if (
        (!environment.production ||
          event.origin.includes(environment.cookieDomain)) &&
        event.data
      )
        switch (event.data.action) {
          case 'GET_USER': {
            const u = this._authServ.currentUser;
            const users = this._authServ.users;
            const res: PostResponse = { action: 'GET_USER', payload: null };
            if (u && users) {
              res.payload = this._storageServ.encryptValue(users[u]);
            }
            window.parent.postMessage(res, event.origin);

            break;
          }
          case 'GET_ALL': {
            const u = this._authServ.currentUser;
            const users = this._authServ.users;
            const res: PostResponse = { action: 'GET_ALL', payload: null };
            if (u && users) {
              const payload = {
                currentUser: users[u],
                sigma: this._authServ.sigmaValue,
                alpha: this._authServ.alphaValue,
                beta: this._authServ.betaValue,
              };
              res.payload = this._storageServ.encryptValue(payload);
            }
            window.parent.postMessage(res, event.origin);
            break;
          }
          case 'UPDATE_TOKEN': {
            if (event.data.payload)
              this._authServ.updateToken(event.data.payload);
            break;
          }
          case 'GET_SIGMA': {
            const res: PostResponse = {
              action: 'GET_SIGMA',
              payload: localStorage.getItem('sigma'),
            };
            window.parent.postMessage(res, event.origin);
            break;
          }
          case 'GET_ALPHA': {
            const res: PostResponse = {
              action: 'GET_ALPHA',
              payload: localStorage.getItem('alpha'),
            };
            window.parent.postMessage(res, event.origin);
            break;
          }
          case 'GET_BETA': {
            const res: PostResponse = {
              action: 'GET_BETA',
              payload: localStorage.getItem('beta'),
            };
            window.parent.postMessage(res, event.origin);
            break;
          }
          case 'UPDATE_SIGMA': {
            this._authServ.setSigma(event.data.payload || undefined);
            break;
          }
          case 'UPDATE_ALPHA': {
            this._authServ.setAlpha(event.data.payload || undefined);
            break;
          }
          case 'UPDATE_BETA': {
            this._authServ.setBeta(event.data.payload || undefined);
            break;
          }
          default:
            break;
        }
    });
    this._authServ.bc.onmessage = (ev) => {
      if (ev.data == 'LOGOUT') {
        const res: PostResponse = { action: 'LOGOUT', payload: null };
        environment.microUrls.forEach((x) =>
          window.parent.postMessage(res, new URL(x).origin)
        );
      }
    };
  }
  protected readonly title = signal('i-auth');
}
